import {
  Autocomplete,
  Box,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateSkillData } from "../../../../../../../store/slices/profile/skillSlice";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { node_server } from "../../../../../../../constants";

const EditSkillMainInfo = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { value: user, activeUserSkill } = useSelector((state) => state.user);
  const { data } = useSelector((state) => state.skill);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!user) return;
    const fetchCategories = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/creator-types/categories`,
        {
          withCredentials: true,
        }
      );
      if (error) console.log(error);
      if (data) {
        const values = data.map((item) => item.category);
        dispatch(
          updateSkillData({
            categories: values,
            specialities: [],
            skillsNames: [],
          })
        );
      }
    };

    if (data.categories.length === 0) fetchCategories();
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const fetchSkills = async () => {
      const { data: skillsNames, error } = await axios.post(
        `${node_server}/api/skills/names`,
        {
          category: data?.category,
        },
        {
          withCredentials: true,
        }
      );

      if (error) console.log(error);
      if (skillsNames) {
        const values = skillsNames.map((item) => item.skill);
        dispatch(updateSkillData({ skillsNames: values, specialities: [] }));
      }
    };

    if (data?.category) fetchSkills();
  }, [data?.category]);

  useEffect(() => {
    if (!user) return;
    const fetchSpecialities = async () => {
      const { data: skillsSpecialities, error } = await axios.post(
        `${node_server}/api/skills/specialities`,
        {
          skillName: data?.name,
        },
        {
          withCredentials: true,
        }
      );

      if (error) console.log(error);
      if (skillsSpecialities) {
        const values = skillsSpecialities.map((item) => item.speciality);
        dispatch(updateSkillData({ specialities: values }));
      }
    };

    if (data?.name) fetchSpecialities();
  }, [data?.name]);

  return (
    <Box className={styles.editSkill}>
      <Box
        className={styles.communityStatus}
        sx={{
          alignSelf: {
            xs: "stretch",
          },
        }}
      >
        <Box className={styles.title}>
          <Typography
            variant="body1"
            color={theme.palette.darkgrey.darkgrey600}
            fontSize="18px"
            fontWeight={500}
          >
            {pathname.includes("edit-skill")
              ? `Edit ${activeUserSkill?.name || activeUserSkill?.category} `
              : "Add"}{" "}
            Skill
          </Typography>
        </Box>
        <Box className={styles.inputField}>
          <Autocomplete
            sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
            options={data.categories ? data.categories : []}
            getOptionLabel={(option) => option}
            value={data?.category ? data?.category : null}
            onChange={(e, newValue) =>
              dispatch(
                updateSkillData({
                  category: newValue,
                  name: null,
                  speciality: null,
                })
              )
            }
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Category" variant="outlined" />
            )}
          />
          <Autocomplete
            sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
            options={data.skillsNames ? data.skillsNames : []}
            getOptionLabel={(option) => option}
            value={data?.name ? data?.name : null}
            onChange={(e, newValue) =>
              dispatch(
                updateSkillData({
                  name: newValue,
                  speciality: null,
                })
              )
            }
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Skill" variant="outlined" />
            )}
          />
          <Autocomplete
            sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
            options={data.specialities ? data.specialities : []}
            getOptionLabel={(option) => option}
            value={data?.speciality ? data?.speciality : null}
            onChange={(e, newValue) =>
              dispatch(
                updateSkillData({
                  speciality: newValue,
                })
              )
            }
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Speciality" variant="outlined" />
            )}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              alignSelf: "stretch",
            }}
          >
            <Checkbox
              sx={{ m: "0px", p: "0px" }}
              checked={data?.isPrimary ? data?.isPrimary : false}
              onChange={(e) =>
                dispatch(updateSkillData({ isPrimary: e.target.checked }))
              }
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                alignSelf: "stretch",
              }}
            >
              <Typography
                variant="body2"
                color={theme.palette.darkgrey.darkgrey500}
              >
                Add This Skill as a Primary Skill
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EditSkillMainInfo;
